'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Description } from '@radix-ui/react-dialog';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const NotificationDescription = forwardRef(({ className, ...props }, ref) => (_jsx(Description, { ref: ref, className: cn('text-body-5 font-normal text-metal-600 lg:text-body-4 dark:text-metal-300', className), ...props })));
NotificationDescription.displayName = Description.displayName;
export { NotificationDescription };
